import { render, staticRenderFns } from "./OrgEmployeesDeleteList.vue?vue&type=template&id=facc16ee"
import script from "./OrgEmployeesDeleteList.vue?vue&type=script&lang=js"
export * from "./OrgEmployeesDeleteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports